const Create = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/Points/Create')
const Single = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/Points/Single')
const Search = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/Points/Search')

export default [
  {
    path: 'points/create',
    name: 'PointsCreate',
    component: Create,
    meta: {
      title: 'Adicionar Ponto',
      ensureCanSeeFunctionalities: false,
      permission: {
        name: 'points',
        action: 'create'
      }
    }
  },
  {
    path: 'points/:id',
    name: 'PointsEdit',
    component: Single,
    meta: {
      title: 'Editar Ponto',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'points',
        action: 'read'
      }
    }
  },
  {
    path: 'points',
    name: 'PointsSearch',
    component: Search,
    meta: {
      title: 'Pontos',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'points',
        action: 'read'
      }
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/dashboard/points.js